import React from 'react';
import Grid from '@mui/material/Grid';
import HelloImg from '../../assets/img/hello.png';
import { Box, Stack, Typography } from '@mui/material';
import { COLORS } from '../Onboarding/_shared/tokens';

export default function HelloContainer({ benefits }) {
    return (
        <Grid item xs={6}
            sx={{
                alignItems: 'center',
                display: { xs: 'none', lg: 'flex' },
                flexDirection: 'column',
                justifyContent: 'center',
                marginTop: 6,
                paddingBottom: 10,
                minHeight: '100%',
            }}
        >
            <img alt="Hello" src={HelloImg} style={{ width: '100%' }} />

            {benefits && (
                <Stack
                    direction="row"
                    spacing={3}
                    sx={{
                        position: 'relative',
                        px: 3,
                        py: 1.75,
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        boxShadow: '0 6px 20px rgba(0,0,0,0.08)'
                    }}
                >
                    {benefits.map(({ Icon, label }) => (
                        <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Icon sx={{ fontSize: 18, color: COLORS.green }} />
                            <Typography sx={{ fontWeight: 700, fontSize: 14 }}>{label}</Typography>
                        </Box>
                    ))}
                </Stack>
            )}
        </Grid>
    );
}